import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setGrossCommissionAmount, setGrossCommissionPercent } from 'bundles/apex/deals/form/store/deal/actions';

import { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export function GrossCommission({ deal, invalid, required, setGrossCommissionAmount, setGrossCommissionPercent }) {
  return <>
    <ManagedFormGroup
      hasError={invalid}
      label="Gross Commission %"
      required={required}
      type="number"
      value={deal.grossCommissionPercent}
      onValueChange={setGrossCommissionPercent}
    />

    <ManagedFormGroup
      hasError={invalid}
      label="Gross Commission $"
      required={required}
      type="currency"
      value={deal.grossCommissionAmount}
      onValueChange={setGrossCommissionAmount}
    />
  </>;
}

GrossCommission.propTypes = {
  ...propTypes,
  setGrossCommissionAmount: PropTypes.func.isRequired,
  setGrossCommissionPercent: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setGrossCommissionAmount,
  setGrossCommissionPercent,
};

export default connect(null, mapDispatchToProps)(GrossCommission);
